// ショットのステータス定義
export const SHOT_STATUS = {
    NEW: 1,                    // NEW（新規）
    UPDATE: 2,                 // UPDATE（更新）
    PRODUCER_PENDING: 3,       // PRODUCER_PENDING（プロデューサー待ち）
    CLIENT_PENDING: 4,         // CLIENT_PENDING（クライアント待ち）
    APPROVED: 5,               // APPROVED（クライアント承認で完了）
    APPROVED_WITH_DELIVERY_FILE: 6, // APPROVED_WITH_DELIVERY_FILE（承認済み + 納品ファイルあり）
    PRODUCER_DONE_CLIENT_UNAPPROVED: 7, // PRODUCER_DONE_CLIENT_UNAPPROVED（プロデューサー意向で完了）
};

// ステータスのラベル（必要に応じて使用）
export const SHOT_STATUS_LABELS = {
    [SHOT_STATUS.NEW]: "新規",
    [SHOT_STATUS.UPDATE]: "更新",
    [SHOT_STATUS.PRODUCER_PENDING]: "プロデューサー待ち",
    [SHOT_STATUS.CLIENT_PENDING]: "クライアント待ち",
    [SHOT_STATUS.APPROVED]: "承認完了",
    [SHOT_STATUS.APPROVED_WITH_DELIVERY_FILE]: "承認完了（納品ファイルあり）",
    [SHOT_STATUS.PRODUCER_DONE_CLIENT_UNAPPROVED]: "保留",
};
